import React from 'react';
import PropTypes from 'prop-types';
import placeholder from '../../images/icons/news_placeholder_small.svg';

const resultsByCategory = (result) => {
  const grouped = { ShowAll: [] };

  result?.forEach((item) => {
    if (item.showAll) {
      grouped.ShowAll.push(item);
    } else {
      if (!grouped[item.category]) {
        grouped[item.category] = [];
      }
      grouped[item.category].push(item);
    }
  });

  return grouped;
};

const noHitCategory = 'NoHit';

const QuickSearchResult = ({ result, selectedItem, searchUrl, onClose }) => {
  const groupedResults = resultsByCategory(result);
  const { ShowAll = [], ...categories } = groupedResults;

  let globalIndex = 0;

  return (
    <div className="flex grow flex-col overflow-auto bg-white lg:absolute lg:left-1/2 lg:top-full lg:z-50 lg:max-h-[70vh] lg:w-screen lg:max-w-[850px] lg:-translate-x-1/2 lg:translate-y-2 lg:transform lg:rounded-2xl lg:border lg:border-[#ccc] lg:p-6">
      <div className="space-y-6 overflow-auto">
        {Object.entries(categories).map(([category, items]) => {
          return (
            <div
              key={category}
              className={category === noHitCategory ? 'mb-0' : 'mb-6'}
            >
              {category !== noHitCategory && (
                <h4 className="text-accent mb-2 text-lg font-extrabold leading-[2.5rem]">
                  {category}
                </h4>
              )}
              <ul className="grid gap-x-4 gap-y-2 lg:grid-cols-2">
                {items.map((item, index) => {
                  const currentGlobalIndex = globalIndex++;
                  return (
                    <li key={`${item.name}-${index}`}>
                      {item.url ? (
                        <a
                          href={item.url}
                          className={`border-border-primary rounded-radius flex items-center gap-6 border px-4 py-2 hover:bg-gray-100 ${selectedItem === currentGlobalIndex ? 'quick-search-result__item--selected bg-gray-100' : ''}`}
                        >
                          {item.hasImage && item.imageSource ? (
                            <img
                              src={item.imageSource}
                              alt={item.name}
                              className="size-15 shrink-0 object-cover"
                            />
                          ) : (
                            <img
                              src={placeholder}
                              alt={item.name}
                              className="size-15 shrink-0 object-cover"
                            />
                          )}
                          <span className="text-accent text-base font-semibold">
                            {item.name}
                          </span>
                        </a>
                      ) : (
                        <div className="text-text-secondary text-center text-base font-semibold">
                          {item.name}
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
        {ShowAll.length > 0 && (
          <div key="show-all" className="mt-4">
            {ShowAll.map((item, index) => (
              <a
                key={index}
                href={searchUrl}
                className="button min-w-[120px] text-sm"
              >
                {item.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

QuickSearchResult.propTypes = {
  result: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
      imageSource: PropTypes.string,
      hasImage: PropTypes.bool,
      showAll: PropTypes.bool,
    })
  ),
  selectedItem: PropTypes.number,
  searchUrl: PropTypes.string,
  onClose: PropTypes.func,
};

export default QuickSearchResult;
